import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import './css/main.css';

// Default setup
import Navigation from './layout/navigation/Navigation';
import WarpLarge from './layout/warp/WarpLarge';
import Footer from './layout/footer/Footer';
import Paragraph from './layout/Paragraph';
import Hero from './layout/hero/Hero';
import ProcessThreeSteps from './layout/Process';
import CardFull from './layout/CardFull';
import NextUp from './layout/warp/NextUp';

// My photo
import frontImage_About from './img/aboutme/bg_mountain.jpg';
import frontImage_process from './img/aboutme/process_img.jpg';
import cardImage_presentation_1 from './img/aboutme/presentation_yow_2017.jpg';
import cardImage_presentation_2 from './img/aboutme/presentation_slideshare.jpg';


const myself = {
  heading: "I'm a product / UX designer who loves learning new things and using them for creating awesome stuff.",
  paragraph: "Hello! I'm Jinju. I've been working as a product designer / UX designer for the last 8 years in Melbourne, Australia (And a little bit in Seoul, South Korea) – researching how we think when we use an app or website to design a user-friendly digital product.\n\n Currently, I'm a UX designer at SEEK - the leading job finding service in Australia. Prior to SEEK, my design range was much broad. I focused on all aspects of the design process at Medibank, Sportsmate, and Itty Bitty Apps.\n\nI hold my empathy as one of my core strengths, along with understanding how my design integrates with a wider team's technical and strategic goals. Ultimately, my creative goal is to design something that anyone can resonate with.",
  featuredImage: {
    backgroundImage: `url(${frontImage_About})`,
  },
}


// * Note - 디자인 프로세스에 대한 설명 *
const processIntro = {
  title: "Design process",
  heading: "I feel the key is stepping away from the computer. Talk to people, jot down on paper, and then find out what we want to feel from the pixels.",
  paragraph: "I have been interested in the design process without graphic tools for many years. Especially in the world where the design tools are getting easier and more approachable. I feel the paradigm of design is moving on to observation, analytics, and story telling.\n\nThe following is my general workflow in a creative project – from a work project to a blog post. ",
  featuredImage: {
    backgroundImage: `url(${frontImage_process})`,
  },
}

const myProcessSummary = {
  heading: "My workflow",
  first: "Discover an opportunity",
  firstDetail: "There are so many nice things we can do. But what is the biggest opportunity?",
  second: "Generate and evaluate",
  secondDetail: "Sketch early and test early - before it becomes too pretty!",
  third: "Add emotion",
  thirdDetail: "Emotionally designed experience is so powerful. You'll be surprised.",
}

const articlesPreso = {
  heading: "I love to learn, try, and make it easier for the next people to learn.",
  paragraph: "From time to time, I do short to long presentations about what I've learnt from the past experience. (In a fun way!) If you are interested, you can find out more from the following links.",
}

const metatag = {
  title: "About me ✴︎ Jinju Jang",
  author: "Jinju Jang",
  url: "http://jinju.io/about",
  description:myself.heading,
  image: "http://jinju.io" + frontImage_About,
}

class AboutMe extends Component {
  render () {
    return(
      <div>
        <Helmet>
          <meta charSet="utf-8"/>
          <title>{metatag.title}</title>
          <meta name="author" content="Jinju Jang"/>
          <meta name="description" content={metatag.description}/>

          {/*-- Google / Search Engine Tags --*/}
          <meta itemprop="name" content={metatag.title}/>
          <meta itemprop="description" content={metatag.description}/>
          <meta itemprop="image" content={metatag.image}/>

          {/*-- Open Graph / Facebook --*/}
          <meta property="og:url" content={metatag.url}/>
          <meta property="og:type" content="website"/>
          <meta property="og:title" content={metatag.title} />
          <meta property="og:description" content={metatag.description}/>
          <meta property="og:image" content={metatag.image}/>

          {/*-- Twitter --*/}
          <meta name="twitter:card" content="summary_large_image"/>
          <meta name="twitter:title" content={metatag.title}/>
          <meta name="twitter:description" content={metatag.description}/>
          <meta name="twitter:image" content={metatag.image}/>
        </Helmet>

        <Navigation />

        <Hero
          title="About me"
          style={myself.featuredImage}
          firstPage
          downArrow/>

        {/* Section 1 - 나에 대해 설명 */}
        <Paragraph
          heading={myself.heading}
          paragraph={myself.paragraph}/>

        {/* Section 2 - 디자인 프로세스에 대한 설명 */}
        <Hero
          title={processIntro.title}
          style={processIntro.featuredImage}/>

        <Paragraph
          heading={processIntro.heading}
          paragraph={processIntro.paragraph}/>

        <ProcessThreeSteps
          heading={myProcessSummary.heading}
          first={myProcessSummary.first}
          firstDetail={myProcessSummary.firstDetail}
          second={myProcessSummary.second}
          secondDetail={myProcessSummary.secondDetail}
          third={myProcessSummary.third}
          thirdDetail={myProcessSummary.thirdDetail}
          />

        {/* Section 3 - 대외활동과  프로세스에 대한 설명 */}
        <Paragraph
          titleText="Presentations"
          heading={articlesPreso.heading}
          paragraph={articlesPreso.paragraph}/>
        <CardFull
          backgroundImage={cardImage_presentation_1}
          title="Upgrading design without design skills"
          tag="Conference talk • 2017"
          pageUrl="https://www.youtube.com/watch?v=erPjS6NfcAA&t=6s"/>
        <CardFull
          backgroundImage={cardImage_presentation_2}
          title="Short presentations"
          tag="From Slideshare • 2015 - 2019"
          pageUrl="https://www.slideshare.net/jinjujang/presentations"/>
        {/* Footer  - 컨택트와 정리 */}
        <NextUp
          previous="SEEK"
          previousURL="/seek"
          next="Generative Art"
          nextURL="/personal"
        />
        <WarpLarge />
        <Footer/>
      </div>
    );
  }
}

export default AboutMe;



// WEBPACK FOOTER //
// ./src/AboutMe.js